// extracted by mini-css-extract-plugin
export default {"container":"_914a51c5","isEmbedded":"_ad376f76","header":"_d177447d","info":"_6335a9cc"};